import {Config} from "../../config/config";
import {environment} from '../../../environments/environment';
import {Website} from "../../websites/website/website";
import {User} from "../../user/user";


export class DashboardUtils {

  public static generateWpAdminRedirectorUrl(websiteId: number, adminUrl: string, userEmail: string = ''): string {
    const ownerWorkspaceId = localStorage.getItem('dbOwnWorkspaceId');
    const currentWorkspaceId = localStorage.getItem('dbCurrentWorkspaceId') || ownerWorkspaceId;
    return Config.wpAdminRedirectorUrl + `?environment=${environment.type}&workspace_id=${currentWorkspaceId}&domain_id=${websiteId}&admin_url=${encodeURIComponent(adminUrl)}` + (userEmail ? `&email=${userEmail}` : '');
  }

  public static redirectToWvcEditor(website: Website, user: User, isMobile: boolean, regenerate: boolean = false, withoutOnboarding: boolean = false): void {
    let params = '';
    if (regenerate) params += '&regenerate=1';
    if (isMobile) params += '&mobilePreview=true';
    if (withoutOnboarding) params += '&without_onboarding=1';

    const websiteUrl = `${website?.adminUrl}admin.php?page=wvc-editor${params}`;
    const previewLink = DashboardUtils.generateWpAdminRedirectorUrl(website?.id, websiteUrl, user?.email);
    setTimeout(() => {
      window.location.replace(previewLink);
    }, 1);
  }


  /**
   * Generate WVC editor URL based on website state
   * @param website - The website object
   * @param user - The user object
   * @param hasFiles - Whether the website has WVC files
   * @param hasOngoingBuild - Whether there's an ongoing generation
   * @returns The WVC editor URL with appropriate query parameters
   */
  public static getWvcEditUrl(
      website: Website,
      user: User,
      hasFiles: boolean = true,
      hasOngoingBuild: boolean = false
  ): any {
    if (!website?.isWVC) {
      return '';
    }

    let params = '';

    // If files are missing, add appropriate params
    if (!hasFiles) {
      // If there's an ongoing build, only add onboarding=1
      if (hasOngoingBuild) {
        params = '&onboarding=1';
      }
      // If no ongoing build, add onboarding=1&from_dashboard=1
      else {
        params = '&onboarding=1&from_dashboard=1';
      }
    }

    const websiteUrl = `${website.adminUrl}admin.php?page=wvc-editor${params}`;
    return DashboardUtils.generateWpAdminRedirectorUrl(website.id, websiteUrl, user.email);
  }

}
